import React from 'react';
import {
  Select,
  MenuItem,
  ListSubheader,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import {
  COMMON_TIMEZONES,
  ALL_TIMEZONES,
  zoneLabel,
} from '../../Util/timezone';

// Reusable IANA timezone selector. Common US zones are surfaced at the top; the
// full IANA list follows for anyone outside them.
//   - value: current IANA zone ('' means "inherit" when includeInherit is set)
//   - onChange(value): fires with the selected IANA name (or '' for inherit)
//   - includeInherit / inheritLabel: adds an "inherit the default" option (used
//     by the per-user picker so a user can fall back to the instance default)
const TimezonePicker = ({
  value,
  onChange,
  includeInherit = false,
  inheritLabel = 'Use instance default',
  label = 'Timezone',
  disabled = false,
}) => {
  // Common zones already cover most selections; only append the long tail.
  const commonValues = COMMON_TIMEZONES.map((z) => z.value);
  const otherZones = ALL_TIMEZONES.filter((z) => !commonValues.includes(z));

  return (
    <FormControl variant="filled" fullWidth disabled={disabled}>
      <InputLabel id="timezone-picker-label">{label}</InputLabel>
      <Select
        labelId="timezone-picker-label"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {includeInherit && (
          <MenuItem value="">
            <em>{inheritLabel}</em>
          </MenuItem>
        )}
        <ListSubheader>Common</ListSubheader>
        {COMMON_TIMEZONES.map((z) => (
          <MenuItem key={z.value} value={z.value}>
            {zoneLabel(z.value)}
          </MenuItem>
        ))}
        <ListSubheader>All timezones</ListSubheader>
        {otherZones.map((z) => (
          <MenuItem key={z} value={z}>
            {z}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TimezonePicker;
